import { Component, Input, OnInit } from '@angular/core';
import { SimpleNavigation } from '@usf/product-types';

@Component({
  selector: 'app-static-refinement-menu',
  templateUrl: './static-refinement-menu.component.html',
  styleUrls: ['./static-refinement-menu.component.scss'],
})
export class StaticRefinementMenuComponent {
  @Input() filterNav: SimpleNavigation;
  constructor() { }
}
